import React, { useCallback, useEffect, useState } from 'react';
import useSetRandomTimer from '@hooks/useSetRandomTimer';
import { useCollection, useDocument } from '@nandorojo/swr-firestore';
import { CollectionPath } from '@typings/collections.enum';
import { InpcItem, InpcScript } from '@typings/store/npcItem.interface';
import styled from 'styled-components';

const Container = styled.div`
  padding: 12px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media (max-width: 480px) {
    display: none;
  }
`;

const Img = styled.div`
  width: 100%;
  max-width: 600px;
  object-fit: contain;

  img {
    width: 100%;
  }
`;

const SpeechBubble = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
  border-radius: 12px;
  background-color: var(--cardBackgroundColor);
  border: 1px solid var(--cardLineColor);
  font-size: 16px;
  z-index: 1;
  width: 100%;
  text-align: center;
  line-height: 1.4;
`;

const NPCName = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--buttonBackgroundColor);
  color: var(--buttonTextColor);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  padding: 8px;
  top: -36px;
  left: 16px;
  font-size: 14px;
`;

type Props = {};
function NPCSec({ }: Props) {
  const setCollectionPath = `${CollectionPath.NPC}`;
  const npcDocId = 'storeNpc';
  const subCollectionPath = 'scripts';

  const { data, set } = useDocument<InpcItem>(
    `${setCollectionPath}/${npcDocId}`,
    { listen: true },
  );

  const { data: scriptList } = useCollection<InpcScript>(
    `${setCollectionPath}/${npcDocId}/${subCollectionPath}`,
    {
      listen: true,
      orderBy: ['createdAt', 'desc'],
    },
  );

  const [randomScript] = useSetRandomTimer({
    randomList: scriptList || [],
  });

  useEffect(() => { }, []);
  return (
    <Container
      style={{
        flexDirection: data?.bubbleDir === 'top' ? 'column' : 'column-reverse',
      }}
    >
      <SpeechBubble>
        <NPCName>{data?.name || 'npc명'}</NPCName>"
        {randomScript
          ? randomScript.contents
          : scriptList && scriptList.length > 0
            ? scriptList[0].contents
            : ''}
        "
      </SpeechBubble>
      <Img>
        <img src={data?.imgURL} alt="NPC" />
      </Img>
    </Container>
  );
}

export default NPCSec;
